import React from 'react';
import {
    NavLink,
    Link
} from 'react-router-dom'

class ProjectNav extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="filter-grid grid_3">
                <NavLink to={`${process.env.PUBLIC_URL}/journals`} exact activeClassName="actv">All</NavLink>
                <div className="filter-links">
                    <NavLink to={`${process.env.PUBLIC_URL}/journals/news`} exact activeClassName="actv" >News</NavLink>
                    <NavLink to={`${process.env.PUBLIC_URL}/journals/gallery`} exact activeClassName="actv" >Gallery</NavLink>
                    <NavLink to={`${process.env.PUBLIC_URL}/journals/research`} exact activeClassName="actv" >Research</NavLink>
                </div>
            </div>
        );
    }
}

export default ProjectNav;


// WEBPACK FOOTER //
// ./src/components/Journals/JournalNav.js